import type {DataRouterDeletePagePayload} from '@github-ui/code-view-types'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'

import {codeViewAppBuilder} from '../config/app-builder'

export function buildCodeViewDeleteRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('codeViewDeleteRoute', {
    path: '/:owner/:repo/delete/:branch/*',
    queries: [mainQuery<DataRouterDeletePagePayload>({encodeFetchPath: true})],
  })
}

export const codeViewDeleteRoute = buildCodeViewDeleteRoute(codeViewAppBuilder)
